import React from 'react';
import { noop } from 'lodash/fp';
import { TableStateProvider } from './TableStateProvider';
import type { TableProps } from '../types';
import { useQueryParams } from '../../../providers/QueryParamsProvider';

function withTableStateProvider(
  WrappedComponent: React.ComponentType<TableProps>
) {
  return (props: TableProps) => {
    const queryParams = useQueryParams();
    const query = props.queryHook?.(queryParams.query);

    return (
      <TableStateProvider
        data={query?.data}
        isFetching={!!query?.isFetching}
        refetch={query?.refetch || noop}
        getRowId={props.getRowId || ((row: Record<string, any>) => row.id)}
        {...props}
      >
        <WrappedComponent {...props} />
      </TableStateProvider>
    );
  };
}

function withUniqueBackfill(TableComponent: React.ComponentType<TableProps>) {
  return function WithUniqueBackfill(props: TableProps) {
    const queryParams = useQueryParams();

    if (!queryParams.query.size) {
      queryParams.push({}, { query: { size: 25 } });
      return null;
    }

    return <TableComponent {...props} />;
  };
}

export default function withTableStateAndUniqueBackfill(
  WrappedComponent: React.ComponentType<TableProps>
) {
  const TableWithState = withTableStateProvider(WrappedComponent);
  return withUniqueBackfill(TableWithState);
}
